import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=4bd23fe0&scoped=true&"
import script from "./PageEditor.vue?vue&type=script&lang=js&"
export * from "./PageEditor.vue?vue&type=script&lang=js&"
import style0 from "./PageEditor.vue?vue&type=style&index=0&id=4bd23fe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd23fe0",
  null
  
)

export default component.exports